module.exports = __webpack_public_path__ + "images/柏纳s长图_04-3.jpg?v=83c7899b";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan2/柏纳s长图_04-3.jpg
 ** module id = 161
 ** module chunks = 1 2
 **/